<div class="mainContent">
  <div class="pageHeader" i18n>Device Info</div>
  <div class="userInfo">
      <mat-card class="userCard">
        <mat-card-header>
          <mat-card-title i18n>Details</mat-card-title>
          <mat-card-subtitle i18n>
            Device basic information
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
              <mat-list *ngIf="selectedDevice">
                <div mat-line>
                  <mat-list-item i18n class="itemQuestion"> ID </mat-list-item>
                  <mat-list-item *ngIf="selectedDevice" class="itemAnswer">{{selectedDevice.id}} </mat-list-item>
                </div>
                <div mat-line>
                  <mat-list-item i18n class="itemQuestion"> Name </mat-list-item>
                  <mat-list-item role="listitem" class="itemAnswer"> {{selectedDevice.name}}</mat-list-item>
                </div>
                <div mat-line>
                  <mat-list-item i18n class="itemQuestion"> Model </mat-list-item>
                  <mat-list-item role="listitem" class="itemAnswer"> {{selectedDevice.model}}</mat-list-item>
                </div>
                <div mat-line>
                  <mat-list-item i18n class="itemQuestion"> OSVersion </mat-list-item>
                  <mat-list-item role="listitem" class="itemAnswer"> {{selectedDevice.osVersion}}</mat-list-item>
                </div>
                <div mat-line>
                  <mat-list-item i18n class="itemQuestion"> Manufacturer </mat-list-item>
                  <mat-list-item role="listitem" class="itemAnswer"> {{selectedDevice.manufacturer}}</mat-list-item>
                </div>
                <div mat-line>
                  <mat-list-item i18n class="itemQuestion"> Platform </mat-list-item>
                  <mat-list-item role="listitem" class="itemAnswer">{{selectedDevice.platform}} </mat-list-item>
                </div>
                <div mat-line>
                  <mat-list-item i18n class="itemQuestion"> AppVersion </mat-list-item>
                  <mat-list-item role="listitem" class="itemAnswer"> {{selectedDevice.appVersion}} </mat-list-item>
                </div>       
                <div mat-line>
                  <mat-list-item i18n class="itemQuestion"> Registration Date </mat-list-item>
                  <mat-list-item role="listitem" class="itemAnswer"> {{selectedDevice.registeredOn}} </mat-list-item>
                </div>              
              </mat-list>               
        </mat-card-content>
      </mat-card>

    <div class="rightSideContent">
      <mat-card class="redLiningTableCard">
        <mat-card-header>
          <mat-card-title i18n>Redlinings</mat-card-title>
          <mat-card-subtitle i18n>
            Redlinings of the device
          </mat-card-subtitle>
          <mat-card-subtitle>
            <mat-form-field class="my-form-field redliningFilterField">
              <mat-label>Filter</mat-label>
              <input matInput (keyup)="redliningFilter($event)">
            </mat-form-field>

            <div class="contentContainer">
              <table mat-table [dataSource]="redDataSource" matSort>

                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> No. </th>
                  <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                </ng-container>

                <ng-container matColumnDef="objectType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Object Type </th>
                  <td mat-cell *matCellDef="let element"> {{element.objectType}} </td>
                </ng-container>

                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Subject </th>
                  <td mat-cell *matCellDef="let element"> {{element.subject}} </td>
                </ng-container>

                <ng-container matColumnDef="content">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Comment </th>
                  <td mat-cell *matCellDef="let element"> {{element.content}} </td>
                </ng-container>

                <ng-container matColumnDef="prioritytext">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Priority Text </th>
                  <td mat-cell *matCellDef="let element"> {{element.priorityText}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedRedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedRedColumns;"></tr>
              </table>
            </div>
          </mat-card-subtitle>
        </mat-card-header>
      </mat-card>

      <mat-card class="deregisterCard">
        <mat-card-header>
          <mat-card-title *ngIf="hasAccess" class="actionButton">
            <button mat-button i18n-matTooltip matTooltip="Copy device code" [cdkCopyToClipboard]="devCode" [disabled]="btnEnable !== '1'" (click)="copyDeleteCode()">
              <mat-icon>content_copy</mat-icon>
            </button>
            <button mat-button (click)="removeDevice()" i18n-matTooltip matTooltip="Unregister">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-card-title>
          <mat-card-title i18n>
            Unregister
          </mat-card-title>
          <mat-card-subtitle i18n>
            Remove registration of the device
          </mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
          <form>
            <mat-form-field class="my-form-field">
              <mat-label i18n>DeviceCode</mat-label>
              <div class="deviceContent">
                <input matInput name="code" [(ngModel)]="devCode" [value]="devCode" type="text" />               
              </div>
            </mat-form-field>

            <mat-form-field class="my-form-field">
              <mat-label i18n>ResponseCode</mat-label>
              <input matInput name="responseCode" [(ngModel)]="responseCode" [value]="responseCode" type="text" />
            </mat-form-field>
          </form>
        </mat-card-content>

        <mat-card-actions>
          <div class="buttonContent">
            <button mat-raised-button type="button" color="primary" [disabled]="!responseCode" (click)="validateAndDeleteDevice()" i18n>UNREGISTER</button>
          </div>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
